// The "Ask ChatGPT about this call" page on a shared ET (?ask=1, from the notetaker email).

export const ASK_AI_TEXT = {
  TITLE: "Ask ChatGPT about this call",
  BODY: "Copy the whole call, paste it into ChatGPT, Claude or Gemini, and ask anything: the decisions, the to-dos, a summary, what someone said about a topic.",
  COPY: "1. Copy the transcript",
  COPYING: "Getting the transcript…",
  COPIED: "Copied ✓",
  COPY_FAILED: "Couldn't copy. Try again.",
  OPEN: "2. Paste it into",
  CLOSE: "Close",
  OPEN_CLIPS: "Open the clips →",
  // Goes in front of the transcript, so the paste alone gets good notes back. Keep in step with
  // NOTES_PROMPT (emo/transcript/notetaker.py), which heads the email's attached transcript.
  PROMPT:
    "Tell me about this meeting. Give me good notes: a short summary, the highlights, the most impactful lines (quoted, with who said them), and any decisions and to-dos. Use bullet points and emojis.\n\nThe transcript (subtitles: a timecode, then what was said):\n\n",
};

export const ASK_AI_APPS = [
  { name: "ChatGPT", url: "https://chatgpt.com/" },
  { name: "Claude", url: "https://claude.ai/new" },
  { name: "Gemini", url: "https://gemini.google.com/app" },
];
